import React, { useContext } from 'react';
import { ConfigContext } from '../../context/Config';
import Button from '../Button';
import ExternalLink from '../ExternalLink';
import './PracticeActions.less';

export type PracticeActionsProps = {
  trainingLink?: string;
  practiceLink?: string;
};

const PracticeActions: React.FC<PracticeActionsProps> = ({
  trainingLink,
  practiceLink,
}) => {
  const { translate } = useContext(ConfigContext);

  const handleClick = (event) => event.stopPropagation();

  return (
    <div className="button-wrapper">
      {!!trainingLink && <ExternalLink href={trainingLink} />}
      {!!practiceLink && (
        <Button href={practiceLink} target="_blank" onClick={handleClick}>
          {translate('ui.practice')}
        </Button>
      )}
    </div>
  );
};

export default PracticeActions;
